var _filter;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCrash = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_150_116)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_150_116)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 150,
    r: 150,
    fill: "#00C7DA",
    fillOpacity: 0.6,
    style: {
      fill: "#00C7DA",
      fill: "color(display-p3 0.0000 0.7804 0.8549)",
      fillOpacity: 0.6
    },
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 150,
    r: 146,
    stroke: "#37C2D7",
    style: {
      stroke: "#37C2D7",
      stroke: "color(display-p3 0.2157 0.7608 0.8431)",
      strokeOpacity: 1
    },
    strokeWidth: 8,
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_150_116)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.3474 159.362C98.6666 162.057 98.4964 164.921 98.6666 167.784L89.8155 175.027C88.7942 175.869 87.4325 175.701 86.5815 174.69C86.0708 174.185 85.9006 173.511 86.0708 172.837L90.1559 153.972C90.3262 152.793 89.6453 151.614 88.4538 151.277H88.2836L68.7091 149.424C67.5176 149.256 66.4964 148.245 66.6666 146.898C66.6666 146.224 67.1772 145.55 67.6879 145.213L84.0283 134.433C85.0496 133.759 85.39 132.412 84.7091 131.401C84.7091 131.233 84.5389 131.233 84.5389 131.064L72.1134 116.073C71.2623 115.062 71.4325 113.715 72.4538 112.873C72.9644 112.367 73.6453 112.199 74.3262 112.367L93.5602 116.242C94.7517 116.41 95.9432 115.736 96.2836 114.557V114.389L98.1559 95.1866C98.3262 94.0075 99.3474 92.9968 100.709 93.1653C101.39 93.1653 102.071 93.6706 102.411 94.1759L113.305 110.346C113.986 111.357 115.347 111.694 116.369 111.02C116.539 111.02 116.539 110.851 116.709 110.851L131.347 98.5554C132.369 97.7132 133.73 97.8816 134.581 98.8922C135.092 99.3976 135.262 100.071 135.092 100.745L132.198 114.557C131.518 115.399 130.837 116.073 130.156 116.915L122.156 127.527L119.433 131.233C111.092 133.422 104.624 139.823 102.411 148.077L99.3474 159.362ZM223.092 192.208C222.411 194.903 220.879 197.429 218.667 199.451C217.986 200.125 217.305 200.63 216.454 201.135L212.879 214.105C212.539 215.116 212.198 216.126 211.518 216.968C209.475 219.495 206.241 220.506 203.177 219.832L195.518 217.811C191.262 216.632 188.709 212.252 189.901 208.041L191.943 200.461L130.156 184.123L127.943 191.534C126.752 195.745 122.326 198.272 118.071 197.093L110.411 195.071C107.347 194.229 104.964 191.703 104.454 188.502C104.284 187.492 104.454 186.312 104.624 185.302L108.198 172.332C107.858 171.49 107.518 170.648 107.177 169.805C106.326 167.11 106.326 164.078 107.007 161.383L110.071 149.761C111.433 145.045 114.837 141.339 119.262 139.318C120.794 138.812 122.326 138.307 123.858 138.139L128.454 132.075L136.454 121.463C139.007 118.094 142.241 115.399 145.986 113.378C149.73 111.525 153.645 110.346 157.901 110.346C160.794 110.178 163.518 110.515 166.241 111.357L196.879 119.442C199.603 120.116 202.156 121.295 204.539 122.811C207.943 125.169 210.837 128.032 213.22 131.401C215.433 134.938 216.964 138.812 217.475 142.855L219.007 155.993L219.858 163.405C222.411 165.426 224.284 167.953 225.475 170.816C226.667 173.848 226.837 177.217 225.986 180.249L223.092 192.208ZM120.794 156.835C119.433 160.71 121.645 164.921 125.56 166.268C125.901 166.437 126.071 166.437 126.411 166.437C131.007 167.616 137.816 170.311 139.007 165.763C140.198 161.215 135.092 152.456 130.496 151.277C126.581 149.929 122.326 152.119 120.964 155.993C120.964 156.33 120.794 156.499 120.794 156.835ZM201.645 145.045C201.475 143.866 201.135 142.687 200.624 141.676C199.092 138.476 196.198 135.949 192.794 135.107L162.156 127.022C161.135 126.853 160.113 126.685 159.092 126.685C155.347 126.853 151.943 128.538 149.56 131.401L141.56 142.013L184.624 153.467L203.518 158.52L201.645 145.045ZM193.135 180.08C191.943 184.628 199.092 185.807 203.688 186.986C207.773 188.502 212.369 186.481 213.901 182.27C215.433 178.227 213.39 173.679 209.135 172.164C208.624 171.995 208.113 171.827 207.773 171.827C203.177 170.479 194.326 175.532 193.135 180.08Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("defs", null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_150_116",
    x: -2,
    y: 0,
    width: 304,
    height: 304,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_150_116"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_150_116",
    result: "shape"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_150_116"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 300,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_150_116"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 126.667,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(66.6665 93.3334)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCrash);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/crash.bc81d391ceb5a4bce3b18cef65ced133.svg";